export default __webpack_public_path__ + "static/media/3.1ab87309.png";